import firebase from 'firebase/app';

import { v4 as uuidv4 } from 'uuid';

const EVENT_NAME = Object.freeze({
  purchase: firebase.analytics.EventName.PURCHASE,
  checkout: firebase.analytics.EventName.BEGIN_CHECKOUT,
});

// Registra uma transação no Google Analytics (Firabase SDK)
export function logPurchaseGA(event, value, option) {
  const params = {
    transaction_id: uuidv4(),
    affiliation: 'LOIT FGTS',
    currency: 'BRL',
    value,
    option,
  };

  firebase.analytics().logEvent(EVENT_NAME[event], params);
}
